export default __webpack_public_path__ + "static/media/ESSC36LTQU01.eba78fba.mp4";